"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const conversionUtils_1 = require("../../conversionUtils");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_dataLakeTape.isIntermediateRecord(tape), `must be a ${types_1.artifactType} record`);
    const { id, artifactSlug, loanProductSlug, creditFacilitySlug, configuration: { query, bindings }, } = tape;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            query,
            bindings,
        },
    };
    if (loanProductSlug) {
        tapeNode.configuration.loanProductSlug = loanProductSlug;
    }
    if (creditFacilitySlug) {
        tapeNode.configuration.creditFacilitySlug = creditFacilitySlug;
    }
    return {
        operationNode: null,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node, graph } = params;
    (0, common_1.finleyAssert)(uinode_1.file_dataLakeTape.isNode(node), `uiNodesToIntermediate: node is not a file_dataLakeTape node: ${node.metadata.tapeBuilderNodeType}`);
    const { operationNode } = (0, conversionUtils_1.getOperationAndTapes)({
        node,
        graph,
    });
    (0, common_1.finleyAssert)(operationNode === null, 'uiNodesToIntermediate: operationNode was not null for file_dataLakeTape');
    const { artifactSlug, query, bindings, creditFacilitySlug, loanProductSlug, } = node.configuration;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug: creditFacilitySlug ?? null,
        loanProductSlug: loanProductSlug ?? null,
        externalFilename: null,
        configuration: {
            query,
            bindings,
        },
    };
    return {
        record,
        operationNode,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map